import { ContentSection, PageWrap, SectionHeading } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../hooks/useAuth";
import { useEffect } from "react";
import { Step } from "../interfaces";

export const ErrorPage = () => {
    const { t } = useTranslation("errorpage");
    const { handleDataTemplateChange } = useAuth();
    useEffect(() => {
        handleDataTemplateChange(Step.ERROR_PAGE, "pagechange", undefined, undefined);
    }, [handleDataTemplateChange]);

    return (
        <ContentSection>
            <PageWrap size="small">
                <div className="u-text-center">
                    <SectionHeading level={1}>{t("errorpage:title")}</SectionHeading>
                    <div>{t("errorpage:text")}</div>
                </div>
            </PageWrap>
        </ContentSection>
    );
};
